import React from 'react'
import Create from '../crud/create'
import fields from './fields'
import menuItems from './menuItems'

const CreateCurriculum = props => {
  return (
    <Create
// @ts-ignore
      title='Create Curriculum'
      fields={fields}
      apiPath='admin/curriculums'
      successRedirectPath={resource => `/events/curriculums/${resource.id}/edit`}
      buildMenuItems={menuItems}
    />
  )
}

export default CreateCurriculum
